/**
 * Hook: SideChat position — right/left/bottom
 * Persisted in localStorage + cross-component sync via custom event
 * Chat KAPATILAMAZ — sadece pozisyon değiştirilir.
 */
import { useEffect, useState } from 'react'

export type SideChatPosition = 'right' | 'left' | 'bottom' | 'center'

const EVENT = 'runai:sidechat-position'

export function useSideChatPosition() {
  const [position, setPosition] = useState<SideChatPosition>(() => {
    return (localStorage.getItem('sidechat-position') as SideChatPosition) ?? 'right'
  })

  useEffect(() => {
    const onChange = (e: Event) => {
      const detail = (e as CustomEvent).detail as SideChatPosition
      if (detail) setPosition(detail)
    }
    window.addEventListener(EVENT, onChange)
    return () => window.removeEventListener(EVENT, onChange)
  }, [])

  const setPos = (pos: SideChatPosition) => {
    localStorage.setItem('sidechat-position', pos)
    setPosition(pos)
    window.dispatchEvent(new CustomEvent(EVENT, { detail: pos }))
  }

  return { position, setPos }
}
